import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/Reveal";

const ROWS = [
  { n: "01", t: "High-risk card processing", d: "Multiple MIDs, load balancing and bank placement for hard-to-place verticals.", img: "/img/pos1.jpg" },
  { n: "02", t: "POS terminals", d: "Countertop, mobile and PIN pad hardware, pre-boarded to your account.", img: "/img/terminal.jpg" },
  { n: "03", t: "Payment gateway", d: "Hosted checkout, API, tokenisation and recurring billing.", img: "/img/card.jpg" },
  { n: "04", t: "Cross-border settlement", d: "US, EU and LATAM lanes with FinBPM as Merchant of Record.", img: "/img/lounge.jpg" },
  { n: "05", t: "ACH & eCheck", d: "Bank-to-bank rails for recurring and high-ticket payments.", img: "/img/pos2.jpg" },
];

export function Solutions() {
  const [active, setActive] = useState(0);
  return (
    <section className="mx-auto max-w-[1400px] px-5 py-28 sm:px-10 sm:py-40" data-testid="solutions-section">
      <Reveal className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <SectionLabel index="03">What we board</SectionLabel>
          <h2 className="mt-6 font-display text-4xl font-medium tracking-tight sm:text-5xl">The merchant stack.</h2>
        </div>
        <Link to="/store" className="btn-ghost self-start" data-testid="solutions-store-link">Shop the storefront <ArrowUpRight className="h-4 w-4" /></Link>
      </Reveal>
      <div className="grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-7">
          {ROWS.map((r, i) => (
            <Reveal key={r.n} delay={i * 0.05}>
              <button onMouseEnter={() => setActive(i)} onFocus={() => setActive(i)} onClick={() => setActive(i)}
                data-testid={`solution-row-${r.n}`}
                className="group grid w-full grid-cols-[3rem_1fr] items-baseline gap-4 border-t border-white/10 py-7 text-left sm:grid-cols-[4rem_1fr_auto]">
                <span className={`font-mono text-sm ${active === i ? "text-[var(--gold)]" : "text-slate-400"}`}>{r.n}</span>
                <span>
                  <span className={`block font-display text-3xl font-medium tracking-tight transition-colors duration-300 sm:text-4xl ${active === i ? "text-white" : "text-slate-400"}`}>{r.t}</span>
                  <span className="mt-2 block max-w-lg text-sm text-slate-300">{r.d}</span>
                </span>
                <ArrowUpRight className={`hidden h-6 w-6 transition-transform duration-300 sm:block ${active === i ? "rotate-45 text-[var(--gold)]" : "text-slate-500"}`} />
              </button>
              {active === i && (
                <img src={r.img} alt={r.t} className="clip-notch mb-6 aspect-[16/10] w-full object-cover lg:hidden" />
              )}
            </Reveal>
          ))}
        </div>
        <div className="hidden lg:col-span-5 lg:block">
          <div className="sticky top-28 aspect-[4/5] overflow-hidden clip-frame">
            {ROWS.map((r, i) => (
              <motion.img key={r.n} src={r.img} alt={r.t} className="absolute inset-0 h-full w-full object-cover"
                initial={false} animate={{ opacity: active === i ? 1 : 0, scale: active === i ? 1 : 1.08 }}
                transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }} />
            ))}
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_35%,transparent_35%,rgba(8,11,17,0.8)_100%)]" />
            <span className="absolute bottom-6 left-6 font-mono text-xs text-slate-200">{ROWS[active].n} / 05</span>
          </div>
        </div>
      </div>
    </section>
  );
}
